var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home_page"},[_c('div',{staticClass:"banner"},[_c('div',{staticClass:"mini_txt"},[_vm._v("Algorithm capability")]),_c('div',{staticClass:"main_txt"},[_vm._v("科技改变未来")]),_c('img',{attrs:{"src":require("@/assets/images/banner-p1.png"),"alt":""}})])])
}]

export { render, staticRenderFns }